module.exports = __webpack_public_path__ + "static/img/mock-interview.9b69bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/mock-interview.png
// module id = dmtC
// module chunks = 1